<section class="ecb-x-admin-list-section">

  <div class="container-fluid">

    <div class="ecb-x-admin-list-card">

      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 class="ecb-section-title">Qualifications</h1>
          <p class="ecb-muted mb-0">
            Manage public filters used by course pages.
          </p>
        </div>

        <button class="ecb-btn-primary" (click)="openNew()">
          Add New
        </button>
      </div>


      <p-table [value]="pagedTags" dataKey="tagId" (onRowReorder)="onRowReorder($event)" responsiveLayout="scroll"
        styleClass="ecb-admin-table">

        <ng-template pTemplate="header">
          <tr class="ecb-admin-table-header-row">

            <th class="ecb-admin-table-header" style="width: 50px">
            </th>

            <th class="ecb-admin-table-header" style="width: 90px">
              Ranking
            </th>

            <th class="ecb-admin-table-header">
              Tag
            </th>

            <th class="ecb-admin-table-header" style="width: 90px; text-align: center;">
              Visible
            </th>
            <th class="ecb-admin-table-header" style="width: 200px;">

              <div class="d-flex align-items-center justify-content-between">

                <span>Dashboard</span>

                <button type="button" class="ecb-dashboard-reset-btn" title="Reset all dashboard positions"
                  [disabled]="!hasDashboardAssignments || isResettingDashboard" (click)="resetDashboardPositions()">

                  <i class="pi pi-refresh"></i>

                </button>

              </div>

            </th>

            <th class="ecb-admin-table-header ecb-admin-table-action-header">
              Action
            </th>

          </tr>
        </ng-template>


        <ng-template pTemplate="body" let-row let-index="rowIndex">

          <tr class="ecb-admin-table-row" [pReorderableRow]="index">

            <td class="ecb-admin-table-cell">

              <i class="pi pi-bars" pReorderableRowHandle title="Drag to reorder" style="cursor: move;">
              </i>

            </td>

            <td class="ecb-admin-table-cell">
              {{ row.ranking }}
            </td>

            <td class="ecb-admin-table-cell">
              {{ row.tagName }}
            </td>


            <!-- Tag Visibility -->
            <td class="ecb-admin-table-cell text-center">

              <button type="button" class="ecb-admin-table-visibility-button" [ngClass]="row.isVisible
      ? 'ecb-tag-visible'
      : 'ecb-tag-hidden'" [disabled]="row.isUpdatingVisibility" (click)="toggleTagVisibility(row)"
                [title]="row.isVisible ? 'Click to hide tag' : 'Click to show tag'">

                <i class="pi" [ngClass]="row.isVisible ? 'pi-eye' : 'pi-eye-slash'">
                </i>

              </button>

            </td>
            <td class="ecb-admin-table-cell">
              <select class="form-select form-select-sm ecb-dashboard-select" [ngModel]="row.dashboard"
                [disabled]="isResettingDashboard || row.isUpdatingDashboard || isDashboardSelectDisabled(row)"
                (ngModelChange)="onDashboardChange(row, $event)">

                <option [ngValue]="null">None</option>

                <option *ngFor="let option of dashboardOptions" [ngValue]="option.value"
                  [disabled]="isDashboardOptionTaken(option.value, row.tagId)" [ngClass]="{
    'ecb-dashboard-option-disabled': isDashboardOptionTaken(option.value, row.tagId)
  }">

                  {{ option.label }}

                </option>

              </select>
            </td>
            <td class="ecb-admin-table-cell ecb-admin-table-action-cell">

              <button type="button" class="ecb-admin-table-action-button ecb-admin-table-edit-button"
                (click)="edit(row)" title="Edit tag">

                <i class="bi bi-pencil-square ecb-admin-table-action-icon"></i>

              </button>

              <!--     <button type="button" class="ecb-admin-table-action-button ecb-admin-table-delete-button"
                (click)="delete(row.tagId)" title="Delete tag">

                <i class="fa fa-trash ecb-admin-table-action-icon"></i>

              </button> -->

            </td>

          </tr>

        </ng-template>

      </p-table>


      <!-- Start Tags Table Footer -->
      <div class="ecb-x-admin-tags-table-footer">

        <div class="row align-items-center gy-3">

          <!-- Showing Records -->
          <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-tags-paginator-info">

              Showing
              {{ startRecord }}–{{ endRecord }}
              of {{ rows.length }} Qualifications

            </div>

          </div>


          <!-- Rows Per Page -->
          <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-tags-paginator-size">

              <label for="tagsPageSize">
                Rows per page
              </label>

              <select id="tagsPageSize" class="form-select form-select-sm" [(ngModel)]="pageSize"
                (ngModelChange)="onPageSizeChange()">

                <option [ngValue]="10">10</option>
                <option [ngValue]="20">20</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>

              </select>

            </div>

          </div>


          <!-- Page Navigation -->
          <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-tags-paginator-navigation">

              <!-- Previous -->
              <button type="button" class="ecb-x-admin-tags-page-button" [disabled]="currentPage === 1"
                (click)="previousPage()">

                Previous

              </button>


              <!-- Page Numbers -->
              <button type="button" *ngFor="let page of pageNumbers" class="ecb-x-admin-tags-page-button"
                [class.ecb-x-admin-tags-page-active]="currentPage === page"
                [attr.aria-current]="currentPage === page ? 'page' : null" (click)="changePage(page)">

                {{ page }}

              </button>


              <!-- Next -->
              <button type="button" class="ecb-x-admin-tags-page-button" [disabled]="currentPage === totalPages"
                (click)="nextPage()">

                Next

              </button>

            </div>

          </div>

        </div>

      </div>
      <!-- End Tags Table Footer -->


      <p-dialog [(visible)]="showDialog" [modal]="true" [style]="{ width: '560px' }" header="Course qualifications">

        <div class="row g-3">

          <div class="col-md-12">

            <label>Name</label>

            <input class="ecb-form-control" [maxLength]="25" [(ngModel)]="editor.tagName">

          </div>


          <!--   <div class="col-md-8">

            <label>Slug</label>

            <input class="ecb-form-control" [maxLength]="25" [(ngModel)]="editor.slug">

          </div>
 -->

          <div class="col-12">

            <label>Description</label>
            <p-editor styleClass="ecb-x-qualification-editor" [(ngModel)]="editor.description"
              [style]="{ height: '200px' }" [modules]="editorModules">
            </p-editor>

            <!--  <textarea class="ecb-form-control" rows="2" [(ngModel)]="editor.description">
        </textarea> -->

          </div>


          <!--  <div class="col-md-12">

            <label>Image Upload</label>

            <input class="ecb-form-control" type="file" accept="image/*" (change)="uploadImage($event)">

            <div class="image-preview-box mt-2" *ngIf="editor.imageUrl">

              <img [src]="editor.imageUrl">

              <span>
                Image uploaded
              </span>

            </div>

          </div> -->


          <div class="col-md-12">

            <app-common-upload label="Course Image" mode="single" folderName="course-images"
              accept=".jpg,.jpeg,.png,.webp,.bmp" [maxFileSizeMB]="5" [maxOriginalFileSizeMB]="30"
              [compressImages]="true" [imageQuality]="0.8" [maxImageWidth]="1600" [maxImageHeight]="1600"
              [(imageUrl)]="editor.imageUrl" (uploadError)="onCourseImageUploadError($event)"></app-common-upload>

          </div>

        </div>


        <ng-template pTemplate="footer">

          <button class="ecb-btn-outline" (click)="showDialog = false">
            Cancel
          </button>

          <button class="ecb-btn-primary" (click)="save()">
            Save
          </button>

        </ng-template>

      </p-dialog>

    </div>
  </div>
</section>


<!-- Start Dashboard Message Popup -->
<p-dialog [(visible)]="showDashboardPopup" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  [style]="{ width: '420px', maxWidth: '95vw' }">

  <div class="text-center p-3">

    <i class="bi" [ngClass]="{
        'bi-question-circle-fill': dashboardPopupType === 'confirm',
        'bi-check-circle-fill': dashboardPopupType === 'success',
        'bi-exclamation-circle-fill': dashboardPopupType === 'error'
      }" [style.color]="dashboardPopupType === 'error' ? '#dc3545' : '#e35d1a'" style="font-size: 48px;">
    </i>

    <h3 class="ecb-dashboard-popup-title mt-3">
      {{ dashboardPopupTitle }}
    </h3>

    <p class="ecb-dashboard-popup-message">
      {{ dashboardPopupMessage }}
    </p>

    <div class="d-flex justify-content-center gap-2 mt-4">

      <button *ngIf="dashboardPopupType === 'confirm'" type="button" class="btn btn-outline-secondary"
        (click)="closeDashboardPopup()">
        Cancel
      </button>

      <button type="button" class="btn ecb-x-corporate-save-button" (click)="confirmDashboardPopup()">
        {{ dashboardPopupType === 'confirm' ? 'Yes, Reset' : 'OK' }}
      </button>

    </div>

  </div>

</p-dialog>
<!-- End Dashboard Message Popup -->



<!-- Start Save Message Dialog -->
<p-dialog [(visible)]="showSaveMessageDialog" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true"
  [style]="{ width: '420px', maxWidth: '94vw' }" header="Qualification" (onHide)="closeSaveMessageDialog()">

  <div class="d-flex align-items-center gap-3 py-3">

    <i class="bi" [ngClass]="{
        'bi-check-circle-fill text-success': saveMessageType === 'success',
        'bi-exclamation-triangle-fill text-warning': saveMessageType === 'warning',
        'bi-x-circle-fill text-danger': saveMessageType === 'error'
      }" style="font-size: 32px;">
    </i>

    <span>{{ saveMessage }}</span>

  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary" (click)="closeSaveMessageDialog()">
      OK
    </button>
  </ng-template>

</p-dialog>
<!-- End Save Message Dialog -->